
import columns from './tableConfig'
import { searchItems } from './searchFormConfig'
import { CancelInvoice, EditInvoice, GetInvoiceIndex } from '../../../api/invoiceMana'
let searchCache = {}
import InvoiceEditModal from "./components/InvoiceEditModal";
import InvoiceUrlsModal from "./components/InvoiceUrlsModal";
import invoiceDetailsDrawer from "./components/invoiceDetailsDrawer/index";
const invoiceStates = [
  {
    "code": 1,
    "name": "待开票"
  },
  {
    "code": 2,
    "name": "开票中"
  },
  {
    "code": 3,
    "name": "已开票"
  },
  {
    "code": 4,
    "name": "已拒绝"
  },
  {
    "code": 5,
    "name": "已取消"
  }
]
const payTypes = {
  1:{
    'code': 1,
    'name': '微信扫码'
  },
  2: {
    'code': 2,
    'name': '支付宝扫码'
  }
}
const payStates = {
  1: {
    'code': 1,
    'name':'未支付'
  }
  ,
  2: {
    'code':2,
    'name':'支付成功'
  }
  ,
  3: {
    'code':3,
    'name': '部分退款'
  }
  ,
  4: {
    'code': 4,
    'name':'全额退款'
  }
  ,
  5: {
    'code':5,
    'name': '关闭支付'
  }
  ,
  6: {
    'code': 6,
    'name':'超时关闭'
  }
}
const invoiceTypes = [
  {
    "code": 1,
    "name": "增值税专用发票"
  },
  {
    "code": 2,
    "name": "增值税普通发票"
  }
]
export default {
  name: 'OrdersIndex',
  components: {
    InvoiceEditModal,
    InvoiceUrlsModal,
    invoiceDetailsDrawer,
  },
  data() {
    return {
      searchItems,
      searching: false,
      columns,
      payStates,
      payTypes,
      invoiceStates,
      invoiceTypes,
      data: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      states: {
        0: '启用',
        1: '禁用'
      },
      showDetailDrawer: false,
      targetApp: null,
      targetTerminal: null,
      detailVisible: false,
      invoiceDetails: {},
      urlVisible: false,
      urlModel: [],
      editModel: null,
      showEditModel: false,
      editLoading: false
    }
  },
  watch: {

  },
  created() {
    this.$nextTick(async () => {
      this.$refs.searchForm.handlerSearch()
    })
  },

  methods: {
    // 查询应用
    async getAllInvoices(page = 1, searchData) {
      try {
        this.loading = true
        // 确定搜索条件
        searchData = searchData || searchCache
        // 缓存搜索条件
        searchCache = searchData
        let { states, dateTimeRange } = searchData

        let from, to
        if (dateTimeRange && dateTimeRange.length) {
          from = dateTimeRange[0].format('YYYY-MM-DD HH:mm:ss')
          to = dateTimeRange[1].format('YYYY-MM-DD HH:mm:ss')
        }
        await GetInvoiceIndex({
          states,
          from,
          to,
          page,
          perPage: this.pagination.pageSize
        }).then(res => {
          let data = res.data.collection
          this.data = data.map(app => Object.assign(app, { key: app.id }))
          this.pagination.current = page
          this.pagination.total = res.data.size
        })
      } catch (error) {
      }
      this.loading = this.searching = false
    },
    // 翻页
    handlePageTurn(pagination, filters, sorter) {
      const { current } = pagination
      this.getAllInvoices(current)
    },

    handleApplyInvoice(){
      this.$router.push({ name: 'applyInvoice' });
    },
    /*
    * 取消发票申请
    */
    handlerCancelInvoice (id){
      this.$confirm({
        title: '确认取消开票申请？',
        content: '取消后，该开票申请将作废',
        okText: '确认',
        cancelText: '取消',
        confirmLoading: true,
        onOk: () => {
          return CancelInvoice(id).then(() => {
            this.getAllInvoices(this.pagination.current)
          })
        }
      })
    },

    handlerDetailDrawer(record) {
      this.invoiceDetails = record
      this.detailVisible = true
    },

    closeDetailDrawer() {
      this.invoiceDetails = {  };
      this.detailVisible = false;
    },
    handleUrlModalShow(urls) {
      this.urlModel = urls || []
      this.urlVisible = true;
    },
    handleUrlModalClose() {
      this.urlModel = [];
      this.urlVisible = false;
    },

    handleOpenEditModal(record){
      const {id, buyerName,buyerTaxNumber,email} = record
      this.editModel = {id, buyerName,buyerTaxNumber,email}
      this.showEditModel = true
    },
    handleCloseEditModal(){
      this.editModel = {}
      this.showEditModel = false
    },
    handleEditModalSubmit(data){
      this.editLoading = true
      let param = Object.assign({id: this.editModel.id},data)
      EditInvoice(param).then(res=>{
        if (res.data.success){
          this.showEditModel = false
          this.getAllInvoices(1)
        }
        this.editLoading = false
      })
    },

  }
}
